export default __webpack_public_path__ + "static/media/avocado2.cda626aa.png";